import { render, staticRenderFns } from "./courseTableMoreMiniApp.vue?vue&type=template&id=fd7a3b1c"
import script from "./courseTableMoreMiniApp.vue?vue&type=script&lang=js"
export * from "./courseTableMoreMiniApp.vue?vue&type=script&lang=js"
import style0 from "./courseTableMoreMiniApp.vue?vue&type=style&index=0&id=fd7a3b1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports